import React from "react";
import EmpNavbar from "./EmpNavbar";

const EmpHeader = () => {
  return (
    <>
      <EmpNavbar />

      <div className="Main_heade_bg">
        <div className="container-fluid">
          <div className="sunder_con_pad">
            <div className="Main_heade_content">
              <img
                className="exptext"
                src="/assets/vimages/exptext.png"
                alt=""
              />

              <ul className="heade_sec">
                <li>
                  <div className="heade_content">
                    <h3>
                      Pariksha Pe Charcha: Empowering Students, Enlightening
                      Minds
                    </h3>
                    <a href="#sunder_video_card" className="btn_style_v1">
                      Watch All 7 Episodes
                    </a>
                  </div>
                </li>
                <li>
                  <div className="img_cutout">
                    {/* <img src="/assets/images/modi_lanfing.png" alt="" /> */}
                    <div className="htext_bg">
                      Join PM Narendra Modi as he interacts with Exam Warriors
                      for engaging sessions about managing time, stress, and
                      more during exams
                    </div>
                  </div>
                </li>
              </ul>

              <a href="#sunder_video_card" className="wae_btn">
                Watch All Episodes
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmpHeader;
